/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemSamplesQuery } from '../../models/get-project-item-samples-query';
import { GetProjectItemSamplesQueryResult } from '../../models/get-project-item-samples-query-result';

export interface ApiProjectItemSamplesGetProjectItemSamplesPost$Params {
  
    /**
     * The query to retrieve a list of project item Sample.
     */
    body?: GetProjectItemSamplesQuery
}

export function apiProjectItemSamplesGetProjectItemSamplesPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemSamplesGetProjectItemSamplesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemSamplesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSamplesGetProjectItemSamplesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemSamplesQueryResult>;
    })
  );
}

apiProjectItemSamplesGetProjectItemSamplesPost.PATH = '/api/ProjectItemSamples/GetProjectItemSamples';
